module.exports = __webpack_public_path__ + "static/img/bottom-logo.8564dd8.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/bottom-logo.png
// module id = h0F1
// module chunks = 1